// extracted by mini-css-extract-plugin
export var readonly = "_eg-1";
export var star = "_eg-0";